// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
  animation: backdropFadeIn 0.3s ease-out;
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(8px);
  }
}

.modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 
    0 32px 64px rgba(0, 0, 0, 0.16),
    0 16px 32px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.05);
  max-width: 420px;
  width: calc(100% - 32px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  position: relative;
  animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.85) translateY(-40px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
  z-index: 1;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 300;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.modal-close:hover {
  background: rgba(248, 249, 250, 0.95);
  color: #495057;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modal-close:active {
  transform: scale(0.95);
}

.modal-header {
  text-align: center;
  padding: 3.5rem 3rem 2rem;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 20px 20px 0 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.modal-header .app-logo {
  font-size: 2.75rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  line-height: 1;
}

.modal-header h2 {
  color: #1a202c;
  font-size: 1.75rem;
  margin-bottom: 0.75rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.modal-header p {
  color: #718096;
  font-size: 1.1rem;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
}

.modal-body {
  padding: 2.5rem 3rem 3.5rem;
  text-align: center;
  background: white;
  border-radius: 0 0 20px 20px;
}

.modal-body .error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  padding: 16px 20px;
  border-radius: 12px;
  margin: 0 0 2rem 0;
  border: 1px solid #fca5a5;
  font-size: 0.95rem;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1);
}

/* Google Login Button Container */
.modal-body > div:not(.error-message) {
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Style the Google login button wrapper */
.modal-body [data-testid="google-login"] {
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  overflow: hidden !important;
}

.modal-body [data-testid="google-login"]:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

.modal-body [data-testid="google-login"]:active {
  transform: translateY(0) !important;
}

.terms-text {
  margin-top: 2.5rem;
  font-size: 0.95rem;
  color: #718096;
  line-height: 1.6;
  font-weight: 400;
  padding: 0 0.5rem;
}

/* Enhanced Mobile responsive */
@media (max-width: 480px) {
  .modal-content {
    width: calc(100% - 16px);
    border-radius: 16px;
    margin: 8px;
  }
  
  .modal-header {
    padding: 2.5rem 2rem 1.5rem;
    border-radius: 16px 16px 0 0;
  }
  
  .modal-body {
    padding: 2rem 2rem 2.5rem;
    border-radius: 0 0 16px 16px;
  }
  
  .modal-header .app-logo {
    font-size: 2.25rem;
  }
  
  .modal-header h2 {
    font-size: 1.5rem;
  }
  
  .modal-header p {
    font-size: 1rem;
  }
  
  .modal-close {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .modal-content {
    width: calc(100% - 12px);
    margin: 6px;
  }
  
  .modal-header {
    padding: 2rem 1.5rem 1.25rem;
  }
  
  .modal-body {
    padding: 1.5rem 1.5rem 2rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/LoginModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;;;uCAGqC;EACrC,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,8DAA8D;EAC9D,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6DAA6D;EAC7D,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,6DAA6D;EAC7D,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE;IACE,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  animation: backdropFadeIn 0.3s ease-out;\n}\n\n@keyframes backdropFadeIn {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(8px);\n  }\n}\n\n.modal-content {\n  background: white;\n  border-radius: 20px;\n  box-shadow: \n    0 32px 64px rgba(0, 0, 0, 0.16),\n    0 16px 32px rgba(0, 0, 0, 0.08),\n    0 0 0 1px rgba(255, 255, 255, 0.05);\n  max-width: 420px;\n  width: calc(100% - 32px);\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  position: relative;\n  animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85) translateY(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #6c757d;\n  z-index: 1;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 300;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.modal-close:hover {\n  background: rgba(248, 249, 250, 0.95);\n  color: #495057;\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.modal-close:active {\n  transform: scale(0.95);\n}\n\n.modal-header {\n  text-align: center;\n  padding: 3.5rem 3rem 2rem;\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  border-radius: 20px 20px 0 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.modal-header .app-logo {\n  font-size: 2.75rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n  line-height: 1;\n}\n\n.modal-header h2 {\n  color: #1a202c;\n  font-size: 1.75rem;\n  margin-bottom: 0.75rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.2;\n}\n\n.modal-header p {\n  color: #718096;\n  font-size: 1.1rem;\n  margin: 0;\n  line-height: 1.5;\n  font-weight: 400;\n}\n\n.modal-body {\n  padding: 2.5rem 3rem 3.5rem;\n  text-align: center;\n  background: white;\n  border-radius: 0 0 20px 20px;\n}\n\n.modal-body .error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #991b1b;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin: 0 0 2rem 0;\n  border: 1px solid #fca5a5;\n  font-size: 0.95rem;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1);\n}\n\n/* Google Login Button Container */\n.modal-body > div:not(.error-message) {\n  margin: 2rem 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Style the Google login button wrapper */\n.modal-body [data-testid=\"google-login\"] {\n  border-radius: 12px !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  border: 1px solid rgba(0, 0, 0, 0.08) !important;\n  overflow: hidden !important;\n}\n\n.modal-body [data-testid=\"google-login\"]:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;\n}\n\n.modal-body [data-testid=\"google-login\"]:active {\n  transform: translateY(0) !important;\n}\n\n.terms-text {\n  margin-top: 2.5rem;\n  font-size: 0.95rem;\n  color: #718096;\n  line-height: 1.6;\n  font-weight: 400;\n  padding: 0 0.5rem;\n}\n\n/* Enhanced Mobile responsive */\n@media (max-width: 480px) {\n  .modal-content {\n    width: calc(100% - 16px);\n    border-radius: 16px;\n    margin: 8px;\n  }\n  \n  .modal-header {\n    padding: 2.5rem 2rem 1.5rem;\n    border-radius: 16px 16px 0 0;\n  }\n  \n  .modal-body {\n    padding: 2rem 2rem 2.5rem;\n    border-radius: 0 0 16px 16px;\n  }\n  \n  .modal-header .app-logo {\n    font-size: 2.25rem;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .modal-header p {\n    font-size: 1rem;\n  }\n  \n  .modal-close {\n    top: 16px;\n    right: 16px;\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 360px) {\n  .modal-content {\n    width: calc(100% - 12px);\n    margin: 6px;\n  }\n  \n  .modal-header {\n    padding: 2rem 1.5rem 1.25rem;\n  }\n  \n  .modal-body {\n    padding: 1.5rem 1.5rem 2rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
